import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService, RegistroPonto } from '../../api.service';

export type DadosRegistroFacial = {
  terminalPublico: boolean;
  empregadorId: string;
  imagemFacialBase64: string;
  descritorFacial: number[];
  tokenTerminal: string;
  offlineId?: string;
};

@Injectable({ providedIn: 'root' })
export class ServicoRegistroFacial {
  constructor(private readonly api: ApiService) {}

  registrar(dados: DadosRegistroFacial): Observable<RegistroPonto> {
    if (dados.terminalPublico) {
      return this.api.registrarPontoPublicoPorFace(
        dados.imagemFacialBase64,
        dados.descritorFacial,
        dados.tokenTerminal,
        dados.offlineId
      );
    }

    return this.api.registrarPontoPorFace(
      dados.empregadorId,
      dados.imagemFacialBase64,
      dados.descritorFacial,
      dados.offlineId
    );
  }
}
